import React, { PureComponent } from 'react'
let Editor = () => (<div />)
let EditorState = {
  createEmpty: () => {},
}

if (process.env.WEBPACK === 'build.client' || process.env.WEBPACK === 'site.dev') {
  Editor = require('./PlainEditor/PlainEditor').default

  // draftToHtml = require('draftjs-to-html')
  // htmlToDraft = require('html-to-draftjs').default
  // Editor = require('react-draft-wysiwyg').Editor
  // EditorState = require('draft-js').EditorState
  // ContentState = require('draft-js').ContentState
  // convertToRaw = require('draft-js').convertToRaw
  // require('react-draft-wysiwyg/dist/react-draft-wysiwyg.css')
}

import PropTypes from 'prop-types'
import Tooltip from 'react-tooltip'
import cx from 'classnames'
import TextArea from 'components/form/TextArea/TextArea'

import s from './Editor.scss'

import helpImage from './images/help.svg'


class ProfilePageEditor extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
  }

  // componentWillReceiveProps({ valueLink }) {
  //   const { valueLink: oldValueLink } = this.props
  //
  //   if (valueLink.value && !oldValueLink.value) {
  //     const content = htmlToDraft(valueLink.value)
  //
  //     if (content) {
  //       const contentState  = ContentState.createFromBlockArray(content.contentBlocks)
  //       const editorState   = EditorState.createWithContent(contentState)
  //
  //       this.setState({
  //         editorState,
  //       })
  //     }
  //   }
  // }

  // onEditorStateChange = (editorState) => {
  //   const { updateValue } = this.props
  //
  //   this.setState({
  //     editorState,
  //   })
  //
  //   console.log(editorState)
  //   console.log(editorState.getCurrentContent())
  //   // updateValue(
  //   //   draftToHtml(convertToRaw(editorState.getCurrentContent()))
  //   // )
  // }

  render() {
    const { className, valueLink, placeholder, type, label, help } = this.props

    return (
      <div className={className}>
        {
          Boolean(help) && (
            <Tooltip className={s.tooltip} id={`tip${label}`} effect="solid" place="top">
              <div dangerouslySetInnerHTML={{__html: help}}/>
            </Tooltip>
          )
        }
        <div className={s.label}>
          {label}
          {
            Boolean(help) && (
              <img
                className={s.help}
                src={helpImage}
                data-tip
                data-for={`tip${label}`}
              />
            )
          }
        </div>
        <div className={cx(s.inputWrapper, {[s.error]: Boolean(valueLink.error)})}>
          <Editor
            valueLink={valueLink}
            placeholder={placeholder}
          />
        </div>
      </div>
    )
  }
}


export default ProfilePageEditor
